import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Division } from 'src/shared/api';
import { divisionFormConfig } from '../division.component';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { takeUntil, filter } from 'rxjs/operators';

/*
	TODO come up with a better approach to this. Right now I _need_
	a FormGroup type back from this dialog. Only problem is it's
	accessing values from components that implement the CVA, which
	can only be listened to through a FormControl. So I'm having to
	do some manual mapping from formcontrol to formgroup.
*/

@Component({
	selector: 'rpshared-division-dialog',
	templateUrl: './division-dialog.component.html',
	styleUrls: ['./division-dialog.component.css'],
})
export class DivisionDialogComponent extends SelfDestruct implements OnInit {
	// CVA components can only be listened to through a form control
	control = new FormControl('') as FormControl;

	group = this.fb.group(divisionFormConfig) as FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		private readonly division: Division,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.setValue(v));

		if (this.division) {
			this.control.setValue(this.division);
		}
	}
}
